/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/population': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm-.141 18c-1.958 0-3.743-.779-5.118-1.982l.023-2.685c0-2.328 1.097-3.917 2.542-4.334a2.536 2.536 0 01-1.907-2.453A2.543 2.543 0 017.938 4a2.524 2.524 0 012.539 2.521c0 1.174-.805 2.12-1.886 2.408 1.384.373 2.325 1.841 2.39 3.954.32-.816.888-1.235 1.563-1.431a1.844 1.844 0 11.935-.003c1.04.28 1.741 1.462 1.741 3.087l.024 1.49c-1.146.999-2.64 1.674-4.218 1.89L9.859 18zm1.121-5.116"/>'
  }
})
